/* ============================================================
   Lune Cart Engine — free-shipping progress bar + upsell
   Non-invasive: listens to cart, injects into the drawer.
   Configure thresholds via window.LUNE_CART (set in layout).
   ============================================================ */
(function(){
  var CFG = window.LUNE_CART || {};
  var THRESHOLD = (CFG.freeShipThreshold || 550) * 100; // in cents (AED)
  var MONEY = CFG.moneyFormat || "AED {{amount}}";
  var ENABLED = CFG.enabled !== false;

  function money(cents){
    var v=(cents/100).toFixed(2);
    return MONEY.replace(/\{\{\s*amount\s*\}\}/, v);
  }

  function buildBar(total){
    var remain = Math.max(THRESHOLD - total, 0);
    var pct = Math.min(100, Math.round((total/THRESHOLD)*100));
    var unlocked = remain <= 0;
    var msg = unlocked
      ? '<strong>Complimentary delivery unlocked.</strong> Your order ships free.'
      : 'You\u2019re <strong>'+money(remain)+'</strong> away from complimentary UAE delivery.';
    return '<div class="lune-ship-bar'+(unlocked?' is-unlocked':'')+'">'
      + '<div class="lune-ship-bar__msg">'
      + '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>'
      + '<span>'+msg+'</span></div>'
      + '<div class="lune-ship-bar__track"><div class="lune-ship-bar__fill" style="width:'+pct+'%"></div></div>'
      + '</div>';
  }

  function getCart(cb){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();}).then(cb).catch(function(){});
  }

  function findDrawerBody(){
    return document.querySelector('cart-drawer [class*="cart-drawer__inner"], cart-drawer .drawer__inner, cart-drawer .cart-items, #CartDrawer .drawer__inner, cart-drawer dialog, .cart-drawer dialog');
  }

  function inject(){
    if(!ENABLED) return;
    getCart(function(cart){
      var host = findDrawerBody();
      if(!host) return;
      var existing = host.querySelector('.lune-ship-bar');
      var html = buildBar(cart.total_price);
      if(existing){ existing.outerHTML = html; }
      else {
        var wrap=document.createElement('div');
        wrap.className='lune-ship-wrap';
        wrap.innerHTML=html;
        host.insertBefore(wrap, host.firstChild);
      }
    });
  }

  // run on cart changes + drawer open
  ['cart:refresh','cart:updated'].forEach(function(ev){document.addEventListener(ev,inject);});
  document.addEventListener('click',function(e){
    if(e.target.closest('[href="/cart"], .cart-icon, cart-icon, [data-cart-toggle]')) setTimeout(inject,300);
  });
  // observe drawer opening (dialog attribute)
  var mo=new MutationObserver(function(muts){
    muts.forEach(function(m){
      if(m.target && (m.target.hasAttribute && (m.target.hasAttribute('open')||m.target.getAttribute('aria-hidden')==='false'))) setTimeout(inject,120);
    });
  });
  document.addEventListener('DOMContentLoaded',function(){
    var d=document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
    if(d) mo.observe(d,{attributes:true,subtree:true,attributeFilter:['open','aria-hidden','class']});
    // intercept add events
    document.addEventListener('cart:add',function(){setTimeout(inject,200);});
    setTimeout(inject,600);
  });
  // also re-inject after fetch to /cart/add or /cart/change
  var _f=window.fetch;
  window.fetch=function(){
    var args=arguments;
    return _f.apply(this,args).then(function(res){
      try{var u=(args[0]&&args[0].url)||args[0];if(typeof u==='string'&&/\/cart\/(add|change|update)/.test(u)) setTimeout(inject,250);}catch(e){}
      return res;
    });
  };
})();
